import { Box, color, Flex, spacing, useColorMode } from 'deepstash-ui';
import useActivity from 'providers/hooks/useActivity';
import useAuth from 'providers/hooks/useAuth';
import useNsiActivity from 'providers/hooks/useNsiActivity';
import React from 'react';
import { Source } from 'types/models';
import { getRemWidthFromColumns } from 'utils/global';

interface SourceCardVerticalProgressProps {
  source?: Source;
}

const SourceCardVerticalProgress: React.FC<SourceCardVerticalProgressProps> = ({
  source,
}) => {
  const { isLoggedIn } = useAuth();
  const { activity } = useActivity();
  const { reads: nsiReads } = useNsiActivity();
  const { colorMode } = useColorMode();

  const isIdeaRead = (ideaId: number) =>
    activity?.reads?.[ideaId] || nsiReads.sessionReads.has(ideaId);

  if (!source) return null;

  return (
    <Flex
      w={getRemWidthFromColumns(1)}
      gridGap={spacing.XS.rem}
      flexDirection="column"
      mt={spacing.XS.rem}
    >
      {(isLoggedIn ? source.ideas : source.ideas.slice(0, 4)).map(
        (idea, index) => (
          <Box
            key={index}
            w={spacing.toRem(4)}
            h={spacing.toRem(
              200 /
                (isLoggedIn ? source.ideas : source.ideas.slice(0, 4)).length,
            )}
            borderRadius={spacing.toRem(2)}
            backgroundColor={
              isIdeaRead(idea.id)
                ? color.success
                : color[colorMode].textDisabled
            }
            transition={'all 0.6s cubic-bezier(.43,.22,.05,.99)'}
            opacity={isIdeaRead(idea.id) ? 0.8 : 0.4}
          />
        ),
      )}
    </Flex>
  );
};

export default SourceCardVerticalProgress;
